<template>
  <section
    :id="element.Oid + '-element'"
    style="position: relative; z-index: 1000"
    class="rounded-sm"
    :style="{
      left: `${100 * (1 + element.startWidth) * element.startPosition - 100 * element.startWidth}%`,
      width: `${element.startWidth * 100}%`,
      opacity: `${element.startOpacity}`,
      marginTop: `${element.startOffset * scaleFactor}px`,
      transform: `scale(${element.startScale * scaleFactor})`,
    }"
  >
    <a v-if="link" :href="link" target="_blank">
      <div v-if="element.text" class='ql-editor' style="padding: 0px;" v-html="element.text" />
    </a>
    <div class='ql-editor min-h-0' style="padding: 0px;" v-else-if="element.text" v-html="element.text" />
  </section>
</template>

<script>
// import Component from "../component_location"
import { hexToRgb, validURL } from "@/utils.js";

export default {
  components: {},

  props: {
    element: { type: Object, default: () => {} },
    scaleFactor: { type: Number, default: 1 },
  },

  data() {
    return {};
  },

  watch: {
    transformedText: function() {
      // APPLY THOSE STYLES, RIGHT?
      this.updateCSS();
    },
  },

  methods: {
    updateCSS() {
      var rgb = hexToRgb(this.element.backgroundColor);
      var backgroundOpacity;
      if (this.element.backgroundOpacity) {
        backgroundOpacity = this.element.backgroundOpacity;
      } else {
        backgroundOpacity = 0;
      }
      // UPDATE TEXT CSS SPECIFIC TO THIS ELEMENT...
      var id = this.element.Oid;
      $(".katex-html").css("color", this.element.equationColor);
      if (rgb == null) {
        return;
      }
      $("#" + id + "-element").css(
        "background",
        `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${backgroundOpacity})`
      );
    },
  },

  computed: {
    transformedText() {
      return this.element.text;
    },
    link() {
      if(this.element.hyperlink && validURL(this.element.hyperlink)) {

        let url = this.element.hyperlink
        if(!url.includes('http')) {
          url = `http://${url}`
        }
        return url;
      }
      return ''
    }
  },

  mounted() {
    this.updateCSS();
  },
};
</script>

<style>
.ql-editor > h1 {
  font-size: 32px;
}
.ql-editor > h2 {
  font-size: 24px;
}
.ql-editor > h3 {
  font-size: 18.72px;
}
.ql-editor > h4 {
  font-size: 16px;
}
.ql-editor > h5 {
  font-size: 13.28px;
}
.ql-editor > h6 {
  font-size: 10.72px;
}
</style>
